import React from 'react';
import ListEntryCards from '../../../react4xp/components/ListEntryCards'

function ListEntryCardsPart({ backgroundColor, title, entryCards }) {
	return <ListEntryCards
		bgColor={backgroundColor}
		title={title}
		entryCards={entryCards?.map(entryCard => {
			return {
				image: entryCard.imageSrc && {
					srcMedium: entryCard.imageSrcMedium?.link,
					src: entryCard.imageSrc.link,
					alt: entryCard.imageSrc.alt
				},
				title: entryCard.title,
				intro: entryCard.intro,
				cta: {
					label: entryCard.linkText,
					href: entryCard.target || entryCard.externalLink,
					isExternal: !entryCard.target
				}
			}
		})}
	/>
}

export default (props) => <ListEntryCardsPart {...props} />
